import React from "react";

import Input from "../../../controls/Input";
import { calculateRequiredRawMaterial } from "../../../../shared/recipeCalculations";
import { digitsAndDecimal, signedDecimal } from "../../../../shared/numericInput";
import Button from "../../../ui/Button";

interface ManufactureNewDetails3Props {
  barcodeScanInProgress: boolean;
  errors?: any;
  handleBarcodeScan: (barcode: string) => void;
  recipeItems?: any;
  handleInputChange: (event: any) => void;
  values: any;
  openManualEntryPopup: () => void;
  selectedRecipe: any;
  setValues: (values: any) => void;
  calculateAmountRequiredForRecipeItems: (weight: string) => void;
  hideBarcodeSection?: boolean;
}

export default function ManufactureNewDetails3(
  props: ManufactureNewDetails3Props,
) {
  const {
    barcodeScanInProgress,
    handleBarcodeScan,
    handleInputChange,
    values,
    openManualEntryPopup,
    selectedRecipe,
    setValues,
    calculateAmountRequiredForRecipeItems,
    hideBarcodeSection = false,
  } = props;

  const handleWeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextWeight = digitsAndDecimal(event.target.value);

    if (selectedRecipe.recipe) {
      setValues({
        ...values,
        new_weight: nextWeight,
        required_total_raw_material: calculateRequiredRawMaterial(
          nextWeight,
          selectedRecipe,
        ),
      });
      calculateAmountRequiredForRecipeItems(nextWeight);
      return;
    }

    handleInputChange({
      target: {
        name: "new_weight",
        value: nextWeight,
      },
    });
  };

  const handleTemperatureChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    handleInputChange({
      target: {
        name: event.target.name,
        value: signedDecimal(event.target.value),
      },
    });
  };

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <div className="col-span-1">
          <Input
            label="Total Target Weight"
            name="new_weight"
            onChange={handleWeightChange}
            value={values.new_weight}
            labelOn={true}
            type="text"
            inputMode="decimal"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-1 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Total Raw Material"
            name="required_total_raw_material"
            value={values.required_total_raw_material}
            labelOn={true}
            disabled={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-1 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Product Temp &deg;C"
            name="new_product_temperature"
            onChange={handleTemperatureChange}
            value={values.new_product_temperature}
            labelOn={true}
            type="text"
            inputMode="decimal"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-1 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Allergens (EN)"
            name="allergens_en"
            onChange={handleInputChange}
            value={values.allergens_en}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-1 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            disabled={true}
          />
        </div>
        {!hideBarcodeSection ? (
          <div className="col-span-2">
            <div className="flex space-x-2 mb-1">
              <label
                htmlFor="scanned_assembly_barcode"
                className={"text-sm block font-medium text-gray-900"}
              >
                Barcode Scanner
              </label>
            </div>
            <input
              name="scanned_assembly_barcode"
              onChange={handleInputChange}
              value={values.scanned_assembly_barcode}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleBarcodeScan(e.currentTarget.value);
                }
              }}
              disabled={barcodeScanInProgress}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-1 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <div>
              <Button
                type="button"
                variant="primary"
                size="sm"
                className="mt-2"
                onClick={() => {
                  openManualEntryPopup();
                }}
              >
                Manual entry
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
